import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Grid } from '@mui/material';
import {
  LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer,
  BarChart, Bar, Legend
} from 'recharts';

export default function Dashboard() {
  const [dailyStats, setDailyStats] = useState([]);

  useEffect(() => {
    async function fetchStats() {
      try {
        const res = await fetch('https://nawalacheck.skiddle.id/stats/data');
        const json = await res.json();
        if (json?.dailyStats) {
          setDailyStats(json.dailyStats);
        }
      } catch (err) {
        console.error('Failed to fetch stats data:', err);
      }
    }
    fetchStats();
  }, []);

  const lineChartData = dailyStats.map(item => ({
    date: item.date,
    total: item.totalDomainsChecked,
  }));

  const barChartData = dailyStats.map(item => ({
    date: item.date,
    blocked: item.blockedDomains,
    notBlocked: item.notBlockedDomains,
    errors: item.errorDomains,
  }));

  return (
    <Grid container spacing={3}>
      {/* Line Chart - Daily Domain Checks */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>Daily Domain Checks</Typography>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={lineChartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="total" stroke="#3f51b5" strokeWidth={3} name="Total Domains Checked" />
              </LineChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </Grid>

      {/* Bar Chart - Daily Results Distribution */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>Daily Results Distribution</Typography>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={barChartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="blocked" fill="#f87171" name="Blocked" />
                <Bar dataKey="notBlocked" fill="#34d399" name="Not Blocked" />
                <Bar dataKey="errors" fill="#facc15" name="Errors" />
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
